import React from "react";

import CopyToClipboard from "@app/analytics/components/CopyToClipboard";

import {
  SpeechBubbleInnerContainer,
  SpeechBubbleOuterContainer,
} from "./styles";

interface TranscriptTurnSpeechBubbleProps {
  /** Whether this speech bubble is the active bubble (e.g. is current
   * turn/paragraph per playback follow-along) */
  active?: boolean;
  /** Raw (unannotated) text content */
  text: string;
  children: React.ReactNode;
  onClick?: () => void;
}

const COPY_TO_CLIPBOARD_STYLE_OVERRIDES = {
  position: "absolute",
  right: -10,
  top: -10,
  backgroundColor: "#FFF",
  borderRadius: "8px",
  padding: 0.5,
  display: "none",
  zIndex: 10,
};

const TranscriptTurnSpeechBubble = ({
  active = false,
  text,
  children,
  onClick,
}: TranscriptTurnSpeechBubbleProps) => {
  return (
    <SpeechBubbleOuterContainer onClick={onClick}>
      <CopyToClipboard
        copyContent={text}
        variant="icon"
        name="speech-bubble-copy-button"
        className="transcript-turn__copy-button"
        sx={COPY_TO_CLIPBOARD_STYLE_OVERRIDES}
        stopPropagation
        tooltipOnCopy={false}
      />
      <SpeechBubbleInnerContainer
        active={active}
        className="transcript-turn__speech-bubble"
      >
        {children}
      </SpeechBubbleInnerContainer>
    </SpeechBubbleOuterContainer>
  );
};

export default TranscriptTurnSpeechBubble;
